<template>
    <sa-page-layout :btnNewVisible="false" :btnConfigurazioniVisible="btnConfigurazioniVisible" :btnRefreshVisible="true" @refresh="onRefresh" :pathResource="pathResource" :showModalLoading="showModalLoading" :linkedit="linkedit" :linkConfigurazioni="linkConfigurazioni">
        <template slot="table-filter">
            <!-- <b-form @submit.prevent="onSubmit">
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                        <label class="sa-label-data">Nome:</label>
                        <b-form-input v-model="filtroConfigurazioneDiari.nome" type="search" id="nome" placeholder="Nome"></b-form-input>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                        <label class="sa-label-data">Descrizione:</label>
                        <b-form-input v-model="filtroConfigurazioneDiari.descrizione" type="search" id="descrizione" placeholder="Descrizione"></b-form-input>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                        <label class="sa-label-data">Stato:</label>
                        <b-form-select id="inline-form-custom-select-pref" v-model="filtroConfigurazioneDiari.stato" value-field="value" text-field="text" class="mb-2 mr-sm-2 mb-sm-0" :options="statoOption" :value="null"></b-form-select>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="sa-padding-right pt-3 pb-3 text-right">
                        <b-button type="submit" variant="info">{{ this.$i18n.t("patients.lblFind") }}</b-button>
                        <b-button type="reset" v-on:click="onReset" variant="danger">{{ this.$i18n.t("patients.lblResetFilter") }}</b-button>
                    </b-col>
                </b-row>
            </b-form> -->
        </template>
        <template slot="table-body">
            <rsa-configurazione-menu-paziente-list-component ref="RsaConfigurazioneMenuPazienteListComponent" @afterLoadData="onAfterLoadData" @beforeLoadData="onBeforeLoadData" @updateFilter="onUpdateFilter"></rsa-configurazione-menu-paziente-list-component>
        </template>
    </sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../../template/sa/components/layout/contents/SaPageLayout.vue";
import RsaConfigurazioneMenuPazienteListComponent from "../components/RsaConfigurazioneMenuPazienteListComponent.vue";
export default {
    components: { SaPageLayout, RsaConfigurazioneMenuPazienteListComponent },
    data() {
        return {
            btnNewVisible: true,
            pathResource: "/rsapazientimenu",
            linkedit: "/rsaconfigurazionediari",
            linkConfigurazioni: "/configurazioni",
            btnConfigurazioniVisible: true,
            showModalLoading: false,
            listKey: 0,
            id: "-1",
            filtroConfigurazioneDiari: { nome: "", descrizione: "", stato: null },
            statoOption: [
                { value: null, text: "- STATO -" },
                { value: "ATTIVO", text: "ATTIVO" },
                { value: "DISATTIVO", text: "DISATTIVO" },
                { value: "SOSPESO", text: "SOSPESO" },
            ],
        };
    },
    mounted() {
        let me = this;
        me.loadData();
    },
    methods: {
        loadData() {
            let me = this;
            me.showModalLoading = true;
            me.$refs.RsaConfigurazioneMenuPazienteListComponent.loadData();
            // me.statoOption.unshift({ value: null, text: "ciao" });
        },
        onRefresh() {
            let me = this;
            me.loadData();
        },
        onAfterLoadData() {
            let me = this;
            me.showModalLoading = false;
        },
        onBeforeLoadData() {
            let me = this;
            me.showModalLoading = true;
        },
        onSubmit() {
            let me = this;
            let sessionStorage = window.sessionStorage;
            sessionStorage["filtroConfigurazioneDiari"] = JSON.stringify(me.filtroConfigurazioneDiari);
            me.loadData();
        },
        onReset() {
            let me = this;
            me.filtroConfigurazioneDiari = { nome: "", descrizione: "", stato: null };
            let sessionStorage = window.sessionStorage;
            sessionStorage["filtroConfigurazioneDiari"] = JSON.stringify(me.filtroConfigurazioneDiari);
            //console.log("onReset", me.filtroConfigurazioneDiari.stato);
            me.loadData();
        },
        onUpdateFilter(filterData) {
            let me = this;
            me.filtroConfigurazioneDiari = filterData;
        },
    },
};
</script>

<style></style>
